import * as types from '../types.js';

/**
 * Formulário — vincular posição de Expedição (#MT-14DB846).
 * Padrão SIAL: datalist com nick/nome/endereço; busca case-sensitive; sem IDs na UI.
 */
export default {

	html: `
		<style>
			#dock-expedition .company { width: 14rem; }
			#dock-expedition .warehouse { width: 14rem; }
			#dock-expedition .location { width: 12rem; }
			#dock-expedition #output_id { width: 6rem; text-align: right; }
			#dock-expedition #order_id { width: 6rem; text-align: right; }
			#dock-expedition #reference { width: 16rem; }
		</style>
		<form id="dock-expedition" class="form" autocomplete="off" novalidate>
			<datalist id="dock-companies"></datalist>
			<datalist id="dock-warehouses"></datalist>
			<datalist id="dock-locations"></datalist>
			<div class="title">Vincular posição de Expedição</div>
			<p class="mts muted" style="max-width:40rem">
				Informe o armazém e a posição marcada como <strong>Expedição</strong>.
				A busca do endereço é case-sensitive (<code>D-01</code> ≠ <code>d-01</code>).
			</p>
			<div class="fsb mtl">
				<label title="Empresa depositante">Empresa<sup>*</sup>
					<input id="company_id" class="company" type="text" list="dock-companies" required readonly>
				</label>
				<label title="Número da saída">Saída
					<input id="output_id" type="text" readonly>
				</label>
				<label title="Número do pedido">Pedido
					<input id="order_id" type="text" readonly>
				</label>
				<label title="Referência do pedido">Referência
					<input id="reference" type="text" readonly>
				</label>
			</div>
			<div class="fsb">
				<label title="Armazém da posição de Expedição">Armazém<sup>*</sup>
					<input id="dock_warehouse_id" class="warehouse" type="text" list="dock-warehouses" required placeholder="Lista após empresa">
				</label>
				<label title="Posição tipo Expedição — digite ou escolha o endereço">Posição Expedição<sup>*</sup>
					<input id="dock_location_id" class="location" type="text" list="dock-locations" required
						placeholder="Após o armazém"
						title="Somente posições com Expedição. Busca case-sensitive.">
				</label>
				<span></span>
			</div>
			<div class="fsb mtm">
				<span></span>
				<span>
					<button type="button" class="bn_Escape button">Fechar</button>
					<button type="button" class="bn_Enter button">Salvar</button>
				</span>
			</div>
		</form>
	`,

	form: {
		selector: '#dock-expedition',
		init(formset) {
			formset.form.eraseValues();
			formset.loadList('#dock-companies', 'companies', { labels: ['nick'], value: 'id' });
			Object.getPrototypeOf(this).init.call(this);
		},
	},

	fields: [
		{ properties: { selector: '#company_id' }, types: [types.pubsub(), types.datalist()] },
		{ properties: { selector: '#output_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#order_id' }, types: [types.number(0, 2)] },
		{ properties: { selector: '#reference' }, types: [] },
		{ properties: { selector: '#dock_warehouse_id' }, types: [
			types.pubsub(),
			types.datalist(),
			types.observer('company_id'),
			types.obs_load_options('warehouses'),
		] },
		{ properties: { selector: '#dock_location_id' }, types: [
			types.pubsub(),
			types.datalist({ caseSensitive: true }),
			types.observer(['company_id', 'dock_warehouse_id']),
			types.obs_location_search_api({
				companyKey: 'company_id',
				warehouseKey: 'dock_warehouse_id',
				isExpedition: true,
			}),
		] },
	],

};
